import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../interface/benefit-info-text.extension.interface';

export class BikeleasingBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return {
      managerSpecific: 'https://www.youtube.com/watch?v=fBHz_U-lACI',
      managerSpecificLabel: 'Bikeleasing X Probonio',
      appSpecific: 'https://www.youtube.com/watch?v=PLy7WGVNcFg',
      appSpecificLabel: 'How to Dienstrad',
      hideGeneral: true,
    };
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/sections/21154671752466--BikeLeasing-x-Probonio';
  }

  renderAdditionalContent(_props: BenefitInfoTextProps): ReactNode {
    return null;
  }
}
